import React__default from 'react';
import PropTypes from 'prop-types';
import { c as classnames } from '../index-6ff23041.js';
import Icon from '../Icon/index.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import '../_rollupPluginBabelHelpers-e8fb2e5c.js';

var css_248z = "[data-gene-ui-version=\"2.13.0\"] .loader-holder{align-items:center;color:var(--hero);display:flex;flex-direction:column;margin:auto;position:relative;text-align:center}[data-gene-ui-version=\"2.13.0\"] .loader-holder.p-static{margin:6rem}[data-gene-ui-version=\"2.13.0\"] .loader-holder.p-absolute{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}[data-gene-ui-version=\"2.13.0\"] .loader-holder .s-medium{font-size:2.8rem}[data-gene-ui-version=\"2.13.0\"] .loader-holder .s-big{font-size:5.4rem}[data-gene-ui-version=\"2.13.0\"] .loader-text{font:600 1.6rem/2rem var(--font-family);margin:1rem 0 0}[data-gene-ui-version=\"2.13.0\"] .bubble-loader{animation:sk-rotate 2s linear infinite;height:6.6rem;position:relative;width:6.6rem}@keyframes sk-rotate{to{transform:rotate(1turn)}}[data-gene-ui-version=\"2.13.0\"] .bubble-loader .dot{animation:sk-bounce 2s ease-in-out infinite;background:var(--hero);border-radius:100%;height:60%;position:absolute;top:0;width:60%}@keyframes sk-bounce{0%,to{transform:scale(0)}50%{transform:scale(1)}}[data-gene-ui-version=\"2.13.0\"] .bubble-loader .dot2{animation-delay:-1s;bottom:0;top:auto}[data-gene-ui-version=\"2.13.0\"] .bar-loader{height:.6rem;left:0;overflow:hidden;position:fixed;top:calc(var(--header-height, .6rem) - .6rem);width:100%}[data-gene-ui-version=\"2.13.0\"] .bar-loader:before{animation:bar-loader .8s linear infinite;background:linear-gradient(270deg,#7eb8ff 30%,#8d14e6 50%,#7eb8ff 70%) no-repeat 50% 50%/100vw .6rem;content:\"\";display:block;height:100%;left:50%;max-width:0;opacity:0;overflow:hidden;position:absolute;top:0;transform:translateX(-50%);width:100%}@keyframes bar-loader{0%,to{opacity:0}10%,90%{opacity:1}0%{max-width:0}to{max-width:100%}}";
styleInject(css_248z);

function BubbleLoader() {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bubble-loader"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "dot dot1"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "dot dot2"
  }));
}
function BusyLoader(props) {
  const {
    type,
    isBusy,
    children,
    className,
    loadingText,
    spinnerSize
  } = props;
  return type === 'bar' ? /*#__PURE__*/React__default.createElement("div", {
    className: "bar-loader"
  }) : isBusy ? /*#__PURE__*/React__default.createElement("div", {
    className: classnames('loader-holder', className)
  }, type === 'spinner' ? /*#__PURE__*/React__default.createElement(Icon, {
    type: "bc-icon-loader s-".concat(spinnerSize)
  }) : /*#__PURE__*/React__default.createElement(BubbleLoader, null), loadingText && /*#__PURE__*/React__default.createElement("div", {
    className: "loader-text"
  }, loadingText)) : children;
}
BusyLoader.propTypes = {
  /**
   * Show loader
   */
  isBusy: PropTypes.bool,
  /**
   * Any valid React node. Renders when "isBusy" is set to false
   */
  children: PropTypes.node,
  /**
   * Show some text when loading
   */
  loadingText: PropTypes.string,
  /**
   * Loader available type/style
   */
  type: PropTypes.oneOf(['spinner', 'bubbles', 'bar']),
  /**
   * Loader size
   */
  spinnerSize: PropTypes.oneOf(['small', 'medium', 'big'])
};
BusyLoader.defaultProps = {
  isBusy: true,
  children: null,
  type: 'spinner',
  spinnerSize: 'small'
};

export { BusyLoader as default };
